(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotlight-slider"] && !Shopify.designMode) return;
  try {
    
  class SpotlightSlider {
    constructor(el) {
      this.el = el;
      this.track = el.querySelector('[data-spot-track]');
      this.slides = Array.from(el.querySelectorAll('[data-spot-slide]'));
      this.prevBtn = el.querySelector('[data-spot-prev]');
      this.nextBtn = el.querySelector('[data-spot-next]');
      this.eyebrowEl = el.querySelector('[data-spot-eyebrow]');
      this.titleEl = el.querySelector('[data-spot-title]');
      this.captionEl = el.querySelector('[data-spot-caption]');
      this.captionTransition = el.dataset.captionTransition === 'true';
      this.captionDuration =
        parseFloat(getComputedStyle(el).getPropertyValue('--spot-caption-duration')) || 250;
      this.current = 0;

      if (this.slides.length === 0) return;

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.goTo(this.current - 1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.goTo(this.current + 1));
      }

      this.track.addEventListener(
        'scroll',
        () => {
          window.clearTimeout(this._scrollTimeout);
          this._scrollTimeout = window.setTimeout(() => this.syncFromScroll(), 100);
        },
        { passive: true }
      );

      this.updateCaption(0, { animate: false });
      this.setActiveSlide(0);
      this.updateArrowState();
    }

    // Marks the centered slide so its caption/label can stay visible at
    // rest (see .spot__slide--active in the stylesheet), independent of
    // hover.
    setActiveSlide(index) {
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('spot__slide--active', i === index);
      });
    }

    updateArrowState() {
      const atStart = this.current === 0;
      const atEnd = this.current === this.slides.length - 1;

      if (this.prevBtn) {
        this.prevBtn.style.visibility = atStart ? 'hidden' : 'visible';
      }
      if (this.nextBtn) {
        this.nextBtn.style.visibility = atEnd ? 'hidden' : 'visible';
      }
    }

    goTo(index) {
      const total = this.slides.length;
      const next = Math.max(0, Math.min(total - 1, index));
      const slide = this.slides[next];
      if (!slide) return;

      const trackRect = this.track.getBoundingClientRect();
      const slideRect = slide.getBoundingClientRect();
      const offset =
        this.track.scrollLeft +
        (slideRect.left - trackRect.left) -
        (trackRect.width - slideRect.width) / 2;

      this.track.scrollTo({ left: offset, behavior: 'smooth' });
      this.current = next;
      this.updateCaption(next);
      this.setActiveSlide(next);
      this.updateArrowState();
    }

    syncFromScroll() {
      const trackRect = this.track.getBoundingClientRect();
      const trackCenter = trackRect.left + trackRect.width / 2;

      let closestIndex = 0;
      let closestDistance = Infinity;

      this.slides.forEach((slide, i) => {
        const rect = slide.getBoundingClientRect();
        const slideCenter = rect.left + rect.width / 2;
        const distance = Math.abs(slideCenter - trackCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });

      if (closestIndex !== this.current) {
        this.current = closestIndex;
        this.updateCaption(closestIndex);
        this.setActiveSlide(closestIndex);
        this.updateArrowState();
      }
    }

    updateCaption(index, { animate = true } = {}) {
      const slide = this.slides[index];
      if (!slide) return;

      const applyText = () => {
        if (this.eyebrowEl) this.eyebrowEl.textContent = slide.dataset.eyebrow || '';
        if (this.titleEl) this.titleEl.textContent = slide.dataset.title || '';
      };

      if (!animate || !this.captionTransition || !this.captionEl) {
        applyText();
        return;
      }

      window.clearTimeout(this._captionTimeout);
      this.captionEl.classList.add('is-fading');
      this._captionTimeout = window.setTimeout(() => {
        applyText();
        this.captionEl.classList.remove('is-fading');
      }, this.captionDuration);
    }
  }

  document.querySelectorAll('[data-spotlight-slider]').forEach((el) => new SpotlightSlider(el));

  } catch(e) { console.error(e); }
})();
})();
